import ReducerBuilder from 'classes/ReducerBuilder';
import viewAllPlatformsInitialState from './initialState';
import {Types} from './actions';

const reducer = ReducerBuilder.make(viewAllPlatformsInitialState)
    .forType(Types.START_ADD_STEPS)
    .reduce((state, action) => {
      state.addingSteps = true;
      state.currentPlatform = action.platform;
    })
    .forType(Types.END_ADD_STEPS)
    .reduce((state, action) => {
      state.addingSteps = false;
      state.currentPlatform = null;
    })
    .forType(Types.START_DELETE_STEPS)
    .reduce((state, action) => {
      state.deletingSteps = true;
      state.currentPlatform = action.platform;
    })
    .forType(Types.END_DELETE_STEPS)
    .reduce((state, action) => {
      state.deletingSteps = false;
      state.currentPlatform = null;
    })
    .forType(Types.START_STEP_NUMBERS_SAVE)
    .reduce((state, action) => {
      state.savingStepOrder = true;
    })
    .forType(Types.END_STEP_NUMBERS_SAVE)
    .reduce((state, action) => {
      state.savingStepOrder = false;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/reducer.js